import React from 'react';
import { connect } from 'react-redux';
import Ax from '../../../components/hoc/Ax';
import Loader from '../../../components/ui/Loader/Loader';
import HttpAPICall from '../../../services/HttpAPICall';
import TapApiUrls, { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import ItemViewInList from '../../inventory/includes/ItemViewInList';
import NumberFormatter from '../../../services/NumberFormater';
import CurrencyFormatter from '../../../services/CurrencyFormatter';
import DateService from '../../../services/DateService';
import AppBaseComponent from '../../../components/AppBaseComponent';
import ItemDetailsModal from '../../items/itemDetails/ItemDetailsModal';

class QuotationDetailModal extends AppBaseComponent {
    
    constructor(props) {
        super(props);
        this.state                      =       {
           detail_loading            :       false,
           quotationDetail                  :       null,
           quotationTransactionID           :       null,
           itemView                         :       "amount",
           
        };
        this.quotationDetailUrl       =    INVENTORY_API_BASE_URL_2 + '/quotation/detail';
        this.itemDetailsRef             =   React.createRef(); 

    }

    componentDidMount() {
       
        if(this.props && this.props.quotationID){
            this.getQuotationDetail(this.props.quotationID)
        }
        if(this.props && this.props.quotationDetail){
            this.setState({quotationDetail : this.props.quotationDetail})
        }
        
     }
 
     componentWillReceiveProps(nextProps){
         if(nextProps.quotationID !== this.props.quotationID){
            this.getQuotationDetail(nextProps.quotationID)
         }
         if(nextProps.quotationDetail !== this.props.quotationDetail){
             this.setState({quotationDetail : nextProps.quotationDetail})
         }
        
     }

    getQuotationDetail        =       (transaction_id)      =>      {
        this.setState({detail_loading : true})
        HttpAPICall.withAthorization('GET', this.quotationDetailUrl + '/' + transaction_id, this.props.access_token, null, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                quotationDetail             :   respData,
                quotationTransactionID      :   respData.transaction_id, 
            });
            
        }).then(() => this.setState({detail_loading : false}));      
    }
    
    viewItemModalInit                    =   (item)  =>  { 
        if(item){
            this.itemDetailsRef.current.modalInit(item)
        }
    }
    checkAllItem() {
        let quotationItemForCheckbox      =   document.getElementsByClassName('quotation_item_id_checkbox')
        if(quotationItemForCheckbox && quotationItemForCheckbox.length > 0) {
            for (let i = 0; i < quotationItemForCheckbox.length; i++) {
                quotationItemForCheckbox[i].checked = document.getElementById('all_check_quotation').checked;
            }
        }
    }
    formatAddress(address) {
        return <>
            {address.address1 ? address.address1 + ", " : ""}  {address.address2 ? address.address2 + ", " : ""}
            {address.landmark ? address.landmark + ", " : ""} {address.city ? address.city + ". " : ""}<br />
            Location : <b>{address.state_name ? address.state_name + ", " : ""}  {address.district_name ? address.district_name + "& " : ""}  {address.pincode ? address.pincode + "." : ""} <br /></b>
            GSTIN   :   <b>{address.gstin ? address.gstin : "-"}</b>
        </>
    }
    
    reqDetailJsx        =       ()      =>      {
        let quotation = this.state.quotationDetail;
        let purchase_summary                    =   [];

        let sub_total_amount                =      quotation && quotation.items &&  quotation.items.length > 0 && quotation.items.map(s => s.item_with_discount).reduce((a, b) => a + b, 0);

        let gstSlabs = {};
        let gstTotalAmount = 0;
        if (quotation && quotation.items && quotation.warehouse_address && quotation.warehouse_address.gstin) {
            quotation.items.forEach((item) => {
                let itemTaxableAmount = Number(item.item_with_discount || 0);
                let itemGst = Number(item.gst || 0);
                if (itemTaxableAmount > 0 && itemGst > 0) {
                    gstSlabs[itemGst] = (gstSlabs[itemGst] || 0) + (itemTaxableAmount * itemGst / 100);
                    gstTotalAmount += itemTaxableAmount * itemGst / 100;
                }
            });
        }

        if (gstTotalAmount > 0) {
            Object.keys(gstSlabs).forEach((gstRate) => {
                let totalTax = gstSlabs[gstRate];
                let isSameState = quotation.customerAddress && quotation.warehouse_address
                    && quotation.customerAddress.state_id == quotation.warehouse_address.state_id;
                if (isSameState) {
                    let splitRate = Number(gstRate) / 2;
                    purchase_summary.push({ key: `CGST ${splitRate}%`, value: (totalTax / 2).toFixed(2) });
                    purchase_summary.push({ key: `SGST ${splitRate}%`, value: (totalTax / 2).toFixed(2) });
                } else {
                    purchase_summary.push({ key: `IGST ${gstRate}%`, value: totalTax.toFixed(2) });
                }
            });
        } else if (quotation && quotation.customerAddress && quotation.warehouse_address && quotation.warehouse_address.gstin) {
            let isSameState = quotation.customerAddress.state_id == quotation.warehouse_address.state_id;
            if (isSameState) {
                purchase_summary.push({ key: 'CGST ', value: "As applicable" });
                purchase_summary.push({ key: 'SGST ', value: "As applicable" });
            } else {
                purchase_summary.push({ key: 'IGST ', value: "As applicable" });
            }
        }

        let tcs_amount                          =  quotation &&  Number(quotation.tcs_rate_vc && quotation.tcs_rate_vc >= 0
            ? quotation && quotation.tcs_type == "Percentage" ? (sub_total_amount*quotation.tcs_rate_vc/100) :  Number(quotation.tcs_rate_vc)
            : 0);
        return (<Ax>

            {this.state.detail_loading ? <Loader />
                : <div className="modal-body ">
                    {this.state.quotationDetail
                        ? <div>
                            <table className="table table-bordered bg-white" >
                                <thead className="table-secondary">
                                    <tr>
                                        <th style={{ width: "33%" }}>ID</th>
                                        <th style={{ width: "33%" }}>Date</th>
                                        <th style={{ width: "33%" }}>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td scope="col">{quotation.transaction_id}</td>
                                        <td scope="col">{DateService.dateTimeFormat(quotation.transaction_date, 'DD-MMM-YYYY')}</td>
                                        <td scope="col" className="align-middle">
                                            {quotation.status ? quotation.status.name : ''}
                                        </td>  </tr>
                                </tbody>
                            </table>
                            <table className="table table-hover table-bordered  table-responsive bg-white mb-0">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "33%" }} >Warehouse</td>
                                        <td colSpan={2}>{quotation.warehouse ? <div><b>{quotation.warehouse.name}</b> <br />
                                            {quotation.warehouse_address ?
                                                <div className='pt-1'>Address : {quotation.warehouse_address.address1 ? quotation.warehouse_address.address1 + ", " : ""}
                                                    {quotation.warehouse_address.address2 ? quotation.warehouse_address.address2 + ", " : ""}
                                                    {quotation.warehouse_address.landmark ? quotation.warehouse_address.landmark + ", " : ""}
                                                    {quotation.warehouse_address.city ? quotation.warehouse_address.city + ". " : "-"} <br />
                                                    Location : <b>{quotation.warehouse_address.state_name}</b> <br />
                                                    GSTIN  : {quotation.warehouse_address.gstin ? quotation.warehouse_address.gstin : "-"} <br />
                                                </div> : "-"}</div> : "-"} <br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "33%" }} >Customer</td>
                                        <td colSpan={2} >{quotation.customer ? <div>{quotation.customer.name}<br />
                                           {(quotation.customerAddress || quotation.customerProject) &&
                                            <div className='py-1'>
                                                Project : {quotation.customerProject ? <span><b>{quotation.customerProject.project_name} </b></span> : "-"} <br/>
                                                Address :  {quotation.customerProject ? this.formatAddress(quotation.customerProject.address ) : this.formatAddress(quotation.customerAddress)} </div> }
                                            
                                            </div>: "-"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td scope="col">Priority & Validity Date</td>
                                        <td style={{ width: "33%" }} className="text-capitalize">{quotation.priority ?? "-"}</td>
                                        <td style={{ width: "34%" }}>{DateService.dateTimeFormat(quotation.validity_date, 'DD-MMM-YYYYY') ?? "-"}</td>

                                    </tr>
                                    <tr>
                                        <td scope="col">Deal</td>
                                        <td scope="col" colSpan={2}>{quotation && quotation.deal_data  ? quotation.deal_data.header : ""}</td>
                                    </tr>
                                    <tr>
                                        <td scope="col">Tag Users</td>
                                        <td scope="col" colSpan={2}>{quotation && quotation.users && quotation.users.length > 0 ? quotation.users.map(u => <div>{u.full_name}</div>) : ""}</td>
                                    </tr>
                                    {quotation.quote_enable_authorized_signatory && quotation.quote_enable_authorized_signatory == 'Y' && <tr>
                                        <td scope="col">Authorized Signatory</td>
                                        <td style={{ width: "33%" }} className="text-capitalize" colSpan={2}>{quotation.authorized_signatory && quotation.authorized_signatory.full_name ? quotation.authorized_signatory.full_name : "-"}</td>

                                    </tr>}
                                    <tr>
                                        <td scope="col">Currency</td>
                                        <td colSpan={2}><b>{quotation.currency}</b> {quotation.currency !== quotation.base_currency ? <span>(1 {quotation?.currency} : <NumberFormatter number={quotation?.conversion_rate} precision={2} /> {quotation?.base_currency})</span> : null}</td>

                                    </tr>
                                    {quotation.additional_attribute_data && quotation.additional_attribute_data.length > 0
                                        ? quotation.additional_attribute_data.map((attr) => {
                                            return (<tr key={attr.key}>
                                                <td scope="col" className='text-capitalize'>{attr.name ? attr.name : "-"}</td>
                                                <td scope="col" colSpan={2}>{attr.value_display ? attr.value_display : "-"}</td>
                                            </tr>)
                                        }) : null}
                                </tbody>
                            </table>

                            <div className="my-3">
                                <label className="form-check-label me-3">Show Item : </label>
                                <input
                                    type="radio"
                                    name="itemView"
                                    value="amount"
                                    checked={this.state.itemView === 'amount'}
                                    onChange={() => this.setState({ itemView: 'amount' })}
                                /> Amount
                                <input
                                    type="radio"
                                    name="itemView"
                                    value="quantity"
                                    checked={this.state.itemView === 'quantity'}
                                    onChange={() => this.setState({ itemView: 'quantity' })}
                                    className="ms-3"
                                /> Quantity
                            </div>

                            {this.state.itemView === "amount" ? <table className="table table-bordered table-responsive bg-white my-3 table-sm" id="poTable">
                                <thead className="table-secondary">
                                    <tr>
                                        <th style={{ "width": '5%' }} className="text-center">
                                            <input type='checkbox' onChange={this.checkAllItem} id="all_check_quotation" />
                                        </th>
                                        <th style={{ width: "39%" }}>Item Details</th>
                                        <th style={{ width: "12%" }} className="text-end">Quantity</th>
                                        <th style={{ width: "8%" }} className="text-end">Unit Rate</th>
                                        <th style={{ width: "8%" }} className="text-end">Discount</th>
                                        <th style={{ width: "8%" }} className="text-end">Tax</th>
                                        <th style={{ width: "8%" }} className="text-end">Amount</th>
                                        {/* <th style={{ width: "8%" }} className="text-center">Pending</th>*/}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        quotation && quotation.items && quotation.items.length > 0 ? quotation.items?.map((i, k) => {
                                            return (<tr>
                                                <td className='text-center'>
                                                    {k + 1}
                                                    <br /><br />
                                                    <input
                                                        type='checkbox'
                                                        name="foo"
                                                        value={k}
                                                        className="quotation_item_id_checkbox"
                                                        data-itemData={i?.item_profile}
                                                        disabled={Number(i.pending_qty || 0) <= 0}
                                                    />

                                                </td>

                                                <td>{i.item_profile ?
                                                    <div className='row'>
                                                        <div className='col-sm-10'>
                                                            <ItemViewInList view_hsn={true} item={i.item_profile} remark={i.remark} due_date={i.due_date_display} viewItemModal={() => this.viewItemModalInit(i.item_profile)} />
                                                        </div>

                                                    </div>
                                                    : null}</td>

                                                <td className='text-end'>{i.qty}
                                                    {i.item_profile.measuring_unit && i.item_profile.measuring_unit.name ? <span className="text-helping input-group-text text-end pr0">{i.item_profile?.measuring_unit?.name}</span> : null}

                                                </td>
                                                <td className='text-end'>{i.rate_vc}</td>
                                                <td className='text-end'>{i.discount_rate_vc ? <div>{i.discount_type == "Fixed" ? quotation.currency : null} {i.discount_rate_vc} {i.discount_type == "Percentage" ? "%" : null}</div> : 0}</td>
                                                <td className='text-end'>{quotation  && quotation.warehouse_address && quotation.warehouse_address.gstin ? <div>{i.gst} %</div> : "NA"}
                                                    {quotation && quotation.warehouse_address && quotation.warehouse_address.gstin && i.item ? <span className="text-helping input-group-text text-end pr0">{quotation.customerAddress && quotation.customerAddress.state_name == quotation.warehouse_address.state_name ? "GST" : "IGST"}</span> : null}
                                                </td>
                                                <td className='text-end'>
                                                    <CurrencyFormatter currencyCode={quotation.currency} amount={parseFloat(i.item_with_discount).toFixed(2)} />
                                                </td>
                                            </tr>)

                                        }) : <tr ><td className='text-center' colSpan={8}>No Record</td></tr>
                                    }
                                </tbody>
                            </table> : <table className="table table-bordered table-responsive bg-white my-3 table-sm" id="poTable">
                                <thead className="table-secondary">
                                    <tr>
                                        <th style={{ "width": '5%' }} className="text-center">
                                            <input type='checkbox' onChange={this.checkAllItem} id="all_check_quotation" />
                                        </th>
                                        <th>Item Details</th>
                                        
                                        <th style={{ width: "14%" }} className="text-end">Quantity</th>
                                         <th style={{ width: "14%" }} className="text-end">SO Qty</th>
                                        <th style={{ width: "14%" }} className="text-end">Allocated</th>
                                        <th style={{ width: "14%" }} className="text-end">Invoiced</th>
                                        <th style={{ width: "14%" }} className="text-end">Pending</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {quotation && quotation.items && quotation.items.length > 0 ? quotation.items.map((i, k) => (
                                        <tr key={k}>
                                            <td className='text-center'>
                                                {k + 1}
                                                <br /><br />
                                                <input
                                                    type='checkbox'
                                                    name="foo"
                                                    value={k}
                                                    className="quotation_item_id_checkbox"
                                                    data-itemData={i?.item_profile}
                                                    disabled={Number(i.pending_qty || 0) <= 0}
                                                />
                                            </td>
                                            <td>{i.item_profile ? <ItemViewInList view_hsn={true} item={i.item_profile} remark={i.remark} due_date={i.due_date_display} viewItemModal={() => this.viewItemModalInit(i.item_profile)} /> : null}</td>
                                            <td className='text-end'>{i.qty ?? "0"}</td>
                                             <td className='text-end'>{i.so_qty ?? "0"}</td>
                                            <td className='text-end'>{i.sa_qty ?? "0"}</td>
                                            <td className='text-end'>{i.si_qty ?? "0"}</td>
                                            <td className='text-end'>{i.pending_qty ?? "0"}</td>
                                        </tr>
                                    )) : <tr><td className='text-center' colSpan={6}>No Record</td></tr>}
                                </tbody>
                            </table>}
                            <div className="row align-items-center">
                                <div className="col-6">
                                    <label htmlFor="notes" className="form-label">Notes</label>
                                    <div>{quotation.notes ?? "-"}</div>

                                </div>
                                <div className="col-6">
                                    <table className="table  table-borderless">
                                        <tbody>
                                            <tr className="subtotal_bg_color">
                                                <th>Sub-Total ({quotation.currency ? quotation.currency : "INR"})</th>
                                                <td className='float-end'>{quotation && quotation.items && quotation.items.length > 0 && <CurrencyFormatter currencyCode={quotation.currency} amount={quotation.items.map(s => Number(s.item_with_discount)).reduce((a, b) => a + b, 0).toFixed(2)} />}</td>
                                                {/* <td className='float-end'>{quotation.total_amount_vc ? (parseFloat(quotation.total_amount_vc) - (parseFloat(quotation.adjustment_amount_vc ?? 0.0) + parseFloat(quotation.total_tax_vc))).toFixed(2) : 0.00}</td> */}
                                            </tr>
                                            {quotation && quotation.tcs_rate_vc && quotation.tcs_rate_vc > 0 ? <tr className="subtotal_bg_color">
                                                <th>TCS ({quotation.tcs_type == "Fixed" ? quotation.currency : null} {quotation.tcs_rate_vc} {quotation.tcs_type == "Percentage" ? "%" : null} )</th>
                                                <td className='float-end'><NumberFormatter number={tcs_amount} precision={2} /></td>
                                                {/* <td className='float-end'>{quotation.total_amount_vc ? (parseFloat(quotation.total_amount_vc) - (parseFloat(quotation.adjustment_amount_vc ?? 0.0) + parseFloat(quotation.total_tax_vc))).toFixed(2) : 0.00}</td> */}
                                            </tr> : null}
                                            {purchase_summary.map((ps, k) => (
                                                <tr key={k} className="subtotal_bg_color">
                                                    <th>{ps.key}</th>
                                                    <td className="text-end">{ps.value}</td>
                                                </tr>
                                            ))}

                                            <tr className="subtotal_bg_color">
                                                <th>Adjustment</th>
                                                <td className='float-end'>{quotation.adjustment_amount_vc ?? 0}</td>
                                            </tr>
                                            <tr className="subtotal_bg_color">
                                                <th>Final Total ({quotation.currency ? quotation.currency : "INR"})</th>
                                                <td className='float-end'>{quotation.total_amount_vc ? <CurrencyFormatter currencyCode={quotation.currency} amount={quotation.total_amount_vc} /> : 0}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="tab_content_wrapper content_heading">Terms & Condition</div>
                            <table className="table table-hover table-bordered bg-white my-3">
                                <thead className='table-secondary'>
                                    <tr>
                                        <th className='text-center' style={{ width: "10%" }}>S.No</th>
                                        <th className='text-start' style={{ width: "25%" }}>Name</th>
                                        <th className='text-start' style={{ width: "65%" }}>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        quotation.tnc && quotation.tnc.length > 0 ? quotation.tnc.map((tc, k) => {
                                            return (<tr key={k}>
                                                <td className='text-center'>{k + 1}</td>
                                                <td>{tc.name}</td>
                                                <td dangerouslySetInnerHTML={{ __html: tc.text }} />
                                            </tr>);
                                        })
                                            : <tr ><td className='text-center' colSpan={3}>No Record</td></tr>
                                    }

                                </tbody>
                            </table>

                        </div>
                        : null}
                </div>}
                <ItemDetailsModal ref={this.itemDetailsRef}  /> 
        </Ax>)
    }
   

    render() {
        return (<div>{this.reqDetailJsx()}</div>)

    }
}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        isc_configuration       :   state.app && state.app.isc_configuration ? state.app.isc_configuration : null,
        default_currency        :   state.app && state.app.default_currency ? state.app.default_currency : 'INR',
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(QuotationDetailModal);